@if (component(); as component) {
<section *ngIf="mappedItems().length > 0" class="ott-list">
  <div class="ott-list__header">
    <div class="ott-list__title">{{ title }}</div>
    @if (seeMoreTarget) {
    <a class="ott-list__button ott-list__button--desktop" [href]="seeMoreTarget">
      Zobacz więcej
    </a>
    }
  </div>

  <tisa-carousel
    #carousel
    class="ott-list__list"
    (scrolledToEnd)="onButtonRightStatusChanges($event)"
    (scrolledToBeginning)="onButtonLeftStatusChanges($event)"
  >
    @for ( item of mappedItems(); track item) {
    <a class="ott-list__tile" [href]="item.routerLink" tisaCarouselItem>
      <div class="overflow-hidden">
        <img
          class="ott-list__item-image"
          [ngClass]="{
            'image-vertical': imageOrientation === UmpireImageOrientation.VERTICAL,
            'image-horizontal': imageOrientation === UmpireImageOrientation.HORIZONTAL || imageOrientation === UmpireImageOrientation.DEFAULT,
          }"
          [src]="
            item.image
              | imageVariant
                : {
                    width: 416,
                    height: isVerticalImageMode ? 555 : 238,
                    format: '.webp',
                    quality: 50
                  }
          "
        />
      </div>
      <div class="ott-list__item-description">
        @if (item.subtitle && item.startTime) {
        <div class="ott-list__item-info">
          <div class="ott-list__item-category">
            {{ item.subtitle }}
          </div>
          <div class="ott-list__item-date first-letter:uppercase">
            @if (item.startTime) {
            {{ item.startTime | relativeTimeFormat }}
            }
          </div>
        </div>
        }
        <div class="ott-list__item-title" [title]="item.title">
          {{ item.title }}
        </div>
      </div>
    </a>
    }
  </tisa-carousel>

  <div class="ott-list__arrows-container">
    <button
      class="ott-list__arrow ott-list__arrow--left"
      (click)="carousel.scrollLeft()"
      [disabled]="buttonLeftDisabled()"
    >
      <app-icon name="arrow-left"></app-icon>
    </button>
    <button
      class="ott-list__arrow ott-list__arrow--right"
      (click)="carousel.scrollRight()"
      [disabled]="buttonRightDisabled()"
    >
      <app-icon name="arrow-right"></app-icon>
    </button>
  </div>

  @if (seeMoreTarget) {
  <div class="ott-list__button-container--mobile">
    <a class="ott-list__button ott-list__button--mobile" [href]="seeMoreTarget">
      Zobacz więcej
    </a>
  </div>
  }
</section>
}
